import { SectionedCard, Text } from "@bridgesplit/ui";
import { VaultRiskItem } from "@bridgesplit/abf-react";

const EXCLUDE_RISKS = ["audits_addresses", "manager"];

export function RiskCard({ risk }: { risk?: VaultRiskItem }) {
    return risk && EXCLUDE_RISKS.includes(risk?.slug) ? null : (
        <SectionedCard title={risk?.title}>
            <Text variant="body1" color="caption" loading={!risk} multiLine loadingWidth="320px">
                {risk?.body}
            </Text>
        </SectionedCard>
    );
}
